module.exports = __webpack_public_path__ + "img/level-icons-jp.d7627cf3.png";